import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

// Small "i" info icon that opens a popup (not a new page) explaining a term.
// Opens on click so it works on touch devices; closes on outside click / Esc.
export default function InfoTooltip({ label, children }) {
  return (
    <Popover className="relative inline-flex">
      <PopoverButton
        aria-label={label ? `About ${label}` : "More info"}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full border border-gray-300 text-[9px] font-semibold leading-none text-gray-400 hover:border-sky-400 hover:text-sky-600 focus:outline-none focus-visible:ring-1 focus-visible:ring-sky-400"
      >
        i
      </PopoverButton>
      <PopoverPanel
        anchor="bottom"
        className="z-50 mt-1 w-56 rounded-lg bg-gray-900 px-3 py-2 text-left text-xs font-normal leading-snug text-gray-100 shadow-lg [--anchor-gap:4px]"
      >
        {label && <div className="mb-0.5 font-semibold text-white">{label}</div>}
        <div className="text-gray-300">{children}</div>
      </PopoverPanel>
    </Popover>
  );
}
